import { useNavigate } from "react-router-dom";
export const TextSignInSignUp = (props) => {
    const navigate = useNavigate();
    const handleNavigate = () => {
        navigate("/signIn");
    };
    return (<div>
      <p className="text-center">
        {props.question}{" "}
        <span className="text-b-mc font-semibold cursor-pointer" onClick={handleNavigate}>
          {props.title}
        </span>
      </p>
    </div>);
};
